import { memo } from "react";
import { StaticImage } from "../StaticImage";
import { useStyles } from "./Directory.style";
import { IActiveIframe } from "./DirectoryRow";
import { TypographyVariant } from "../../../constants/typography";
import { Typography } from "../../core/Typography/Typography";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../../constants/historyGaming";
import { FeaturedCard } from "@onmo/graphql/graphql";
import { HomepageMd } from "../../../models/homepage";
import { withTgpSource } from "../../../models/externalLink";
import { shouldRedirectExternal } from "../../../models/theme";
import { useAppSelector } from "../../hooks";

interface IServiceItem {
  id: string;
  title: string;
  icon: string;
  link: string;
}

interface IDirectoryIconProps {
  item: FeaturedCard | IServiceItem;
  handleActiveIframe: (item: IActiveIframe) => void;
  isServices?: boolean;
}

const DirectoryItemIcon: React.FC<IDirectoryIconProps> = ({
  item,
  handleActiveIframe,
  isServices,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { theme } = useAppSelector((state) => state.theme);

  if (isServices) {
    const service = item as IServiceItem;
    const handleActiveIframe = (id: string) => {
      if (shouldRedirectExternal(theme)) {
        window.location.replace(withTgpSource(service.link));
        return;
      }
      navigate(`${PageRoutes.Feed}?category=${id}`);
    };
    return (
      <>
        <div key={service.title} className={classes.title}>
          <StaticImage
            src={service.icon}
            alt={`service-image-set`}
            width={101}
            height={101}
            className={classes.imgGame}
            onClick={() => handleActiveIframe(service.id)}
          />
          <Typography
            variant={TypographyVariant.BodyB5Medium}
            className={classes.title}
          >
            {service.title}
          </Typography>
        </div>
      </>
    );
  }

  const displayItem = item as FeaturedCard;

  return (
    <div key={displayItem.id} className={classes.title}>
      <StaticImage
        src={HomepageMd.getLocalizedAssets(displayItem.assets)?.icon ?? ""}
        alt={`${displayItem.id}-service`}
        width={101}
        height={101}
        className={classes.imgGame}
        onClick={() =>
          handleActiveIframe({
            feedId: displayItem.id,
            activeIframe: HomepageMd.getLink(displayItem),
            background:
              HomepageMd.getLocalizedAssets(displayItem.assets)?.image3X ?? "",
          })
        }
      />
      <Typography
        variant={TypographyVariant.BodyB5Medium}
        className={classes.title}
      >
        {HomepageMd.getLocalized(displayItem.title)}
      </Typography>
    </div>
  );
};

export const DirectoryItem = memo(DirectoryItemIcon);
